

<template>
  

  <ion-page>
    <ion-header>


    </ion-header>

    <ion-content :fullscreen="true">
        <ion-grid class="grid">
        <div class="cover" :style="{'background-image': background}">
        {{changeBackgroud()}}
        <ion-row>
        <ion-col  sizeXs="12" sizeMd="12" sizeLg="12">
            <ion-button end color="dark" routerLink="/music/recommended">Back</ion-button>
          </ion-col>
        </ion-row>

        <ion-row>
        <ion-col  sizeXs="12" sizeMd="12" sizeLg="9">
        <span class="playlist">Playlist</span>
      <br>
      <span class="playlistTitle"><b>{{titleOfPlayList}}</b></span>
        </ion-col>

          <ion-col>
              <ion-img class ="coverImage"  v-bind:src="coverImageArt" ></ion-img>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeXs="12" sizeMd="12" sizeLg="12">      
              
              <ion-button color="success" @click="addToSpotify()">
              Add to Spotify</ion-button>
              
        </ion-col>
        
        </ion-row>
      </div>
        <div class="songList">
        <ion-row>
          <ion-col sizeXs="12" sizeMd="12" sizeLg="12">   
          <span class="songs"><b>Songs</b></span>   




      <ion-list class="list" >
          <ion-item v-for="n in listsongs.songs" :key="n.spotifyId">
              <ion-thumbnail slot="start">
                <ion-img :src="n.imgUrl" @click="playMusic(n.spotifyUrl)"></ion-img>
              </ion-thumbnail>

              <ion-label>
                <h3><b>{{n.songName}}</b></h3>
                <p class="artists" v-for="z in n.artists" :key="z.artists">{{z}}</p>
              </ion-label>

            <ion-button item-end @click="playMusic(n.spotifyUrl)">Play</ion-button>

          </ion-item>
          
     </ion-list>

    <!-- <ion-list>
      <ion-item v-for="n in listsongs.songs" :key="n.spotifyId">
        <ion-label>{{n.songName}}</ion-label>
      </ion-item>
    </ion-list> -->

        </ion-col>
        </ion-row>
        </div>
      </ion-grid>

      <Tabs></Tabs>


  </ion-content>
  <ion-fab class="share" edge slot="fixed">
 <ion-fab-button color="light">
          <ion-icon :icon="share" />
        </ion-fab-button>
        <ion-fab-list side="start">
          <ion-fab-button color="light" @click="twitter">
            <ion-icon :icon="logoTwitter" />
          </ion-fab-button>
          <ion-fab-button color="light" @click="facebook">
            <ion-icon :icon="logoFacebook" />
          </ion-fab-button>
        </ion-fab-list>
    </ion-fab>
  </ion-page>
</template>


<script lang="ts">
import axios from 'axios';

import { IonPage, IonHeader, IonContent, IonImg, IonButton, loadingController } from '@ionic/vue';
import { share, logoTwitter, triangle, radio, disc,logoFacebook } from 'ionicons/icons';

import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
// import Vibrant from 'Vibrant';
// import Vibrant from 'node-vibrant'


export default defineComponent({
  props: {
    timeout: { type: Number, default: 2000 }, //For Spinner timeout
    
  },
  name: 'Tab2',
  components: { IonPage, IonHeader, IonContent, IonImg, IonButton},
  data() {
    return {
      coverImageArt : 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/eb777e7a-7d3c-487e-865a-fc83920564a1/d7kpm65-437b2b46-06cd-4a86-9041-cc8c3737c6f0.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3sicGF0aCI6IlwvZlwvZWI3NzdlN2EtN2QzYy00ODdlLTg2NWEtZmM4MzkyMDU2NGExXC9kN2twbTY1LTQzN2IyYjQ2LTA2Y2QtNGE4Ni05MDQxLWNjOGMzNzM3YzZmMC5qcGcifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6ZmlsZS5kb3dubG9hZCJdfQ.jgGhagSdo7F0atzSBenaqBDiHFUQiHmQQKDIny5cA2o',
      titleOfPlayList: 'Playlist',
      background: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1030%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(163%2c 8%2c 1%2c 1)'%3e%3c/rect%3e%3cpath d='M1266.74 249.36 a166.84 166.84 0 1 0 333.68 0 a166.84 166.84 0 1 0 -333.68 0z' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M395.909%2c258.245C429.983%2c258.337%2c450.119%2c224.278%2c467.028%2c194.696C483.754%2c165.433%2c500.356%2c132.194%2c485.155%2c102.11C468.815%2c69.773%2c432.118%2c52.673%2c395.909%2c53.948C361.73%2c55.152%2c332.267%2c77.468%2c316.925%2c108.034C303.03%2c135.717%2c311.04%2c166.897%2c325.455%2c194.312C341.274%2c224.396%2c361.92%2c258.153%2c395.909%2c258.245' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M1152.902%2c686.365C1204.407%2c686.667%2c1254.277%2c661.907%2c1279.192%2c616.828C1303.4%2c573.028%2c1294.923%2c519.677%2c1268.53%2c477.157C1243.649%2c437.073%2c1200.073%2c414.199%2c1152.902%2c413.372C1104.12%2c412.517%2c1055.52%2c431.373%2c1030.032%2c472.975C1003.457%2c516.352%2c1003.769%2c571.276%2c1029.153%2c615.361C1054.588%2c659.534%2c1101.931%2c686.066%2c1152.902%2c686.365' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M880.248%2c588.274C935.313%2c590.334%2c981.668%2c549.873%2c1007.588%2c501.246C1031.945%2c455.55%2c1030.73%2c400.625%2c1003.87%2c356.354C977.988%2c313.695%2c930.109%2c293.265%2c880.248%2c291.364C826.195%2c289.303%2c765.455%2c298.998%2c739.147%2c346.262C713.268%2c392.756%2c741.604%2c446.33%2c768.405%2c492.299C794.925%2c537.785%2c827.632%2c586.306%2c880.248%2c588.274' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M-6.276%2c551.408C9.078%2c551.621%2c24.067%2c544.339%2c31.495%2c530.9C38.715%2c517.837%2c35.598%2c502.152%2c28.075%2c489.26C20.623%2c476.488%2c8.499%2c466.76%2c-6.276%2c466.17C-22.091%2c465.538%2c-37.948%2c472.531%2c-45.735%2c486.311C-53.417%2c499.905%2c-50.369%2c516.524%2c-42.275%2c529.877C-34.507%2c542.692%2c-21.261%2c551.2%2c-6.276%2c551.408' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M989.806%2c476.324C1023.128%2c475.626%2c1055.244%2c462.931%2c1073.449%2c435.013C1093.526%2c404.224%2c1101.331%2c364.77%2c1083.511%2c332.621C1065.236%2c299.65%2c1027.501%2c284.512%2c989.806%2c284.112C951.311%2c283.704%2c911.956%2c297.323%2c892.591%2c330.595C873.129%2c364.035%2c878.394%2c406.462%2c899.865%2c438.649C919.198%2c467.63%2c954.976%2c477.054%2c989.806%2c476.324' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M1151.48 261.67 a151.62 151.62 0 1 0 303.24 0 a151.62 151.62 0 1 0 -303.24 0z' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M-105.66 451.58 a147.24 147.24 0 1 0 294.48 0 a147.24 147.24 0 1 0 -294.48 0z' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M577.369%2c226.401C591.96%2c225.933%2c605.192%2c218.379%2c612.686%2c205.85C620.395%2c192.961%2c621.569%2c177.256%2c614.772%2c163.864C607.256%2c149.055%2c593.975%2c136.431%2c577.369%2c136.264C560.536%2c136.094%2c546.731%2c148.337%2c538.637%2c163.097C530.879%2c177.244%2c529.473%2c194.488%2c537.893%2c208.25C545.994%2c221.491%2c561.854%2c226.899%2c577.369%2c226.401' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float3'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1030'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3cstyle%3e %40keyframes float1 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-10px%2c 0)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float1 %7b animation: float1 5s infinite%3b %7d %40keyframes float2 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-5px%2c -5px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float2 %7b animation: float2 4s infinite%3b %7d %40keyframes float3 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(0%2c -10px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float3 %7b animation: float3 6s infinite%3b %7d %3c/style%3e%3c/defs%3e%3c/svg%3e")`,
      listsongs: [],
      finalid: `null`
    }
  },
  updated: function(){
    this.isLogin();
    const url = window.location.href;
    const id = url.split('/');
    this.finalid = id[id.length - 1]
    
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getPlaylist?playlistId=' + this.finalid)
      .then(
        res => {
          const imageUrl = res.data.songs[0].imgUrl;
          this.titleOfPlayList = res.data.playlistName;
          this.changeBackgroud(imageUrl);
          this.coverImageArt = res.data.songs[0].imgUrl;
          this.listsongs = res.data;
        }
      );

  },
  mounted:function(){
        this.presentLoadingWithOptions()
  },
  methods: {
    async presentLoadingWithOptions() {
      const loading = await loadingController
        .create({
          spinner: 'circles',
          duration: this.timeout,
          message: 'Loading Playlist',
          translucent: true,
          cssClass: 'custom-class custom-loading',
          backdropDismiss: false
        });

      await loading.present();

      setTimeout(function() {
        loading.dismiss()
      }, this.timeout);
    },

    changeBackgroud(url: string){
      if(url !== undefined){
      console.log(url);

      // const v = new Vibrant(url);
      // const v = new Vibrant(url);
      // v.getPalette((err, palette) => console.log(palette))


      // v.getPalette((err, palette) => console.log(palette));
        // const colorThief = new ColorThief();
        // const img = document.querySelector('img');

        // Make sure image is finished loading
        // if (img.complete) {
        //   colorThief.getColor(img);
        // } else {
        //   image.addEventListener('load', function() {
        //     colorThief.getColor(img);
        //   });
        // }
        



     axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/tryColor?imgUrl=' + url)
      .then(
          res => {
            console.log(res);
    
              console.log("OM")
              console.log(res.data.colors.dominant.r)
              console.log(res.data.colors.dominant.g)
              console.log(res.data.colors.dominant.b)
              const backgroundChange = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1030%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(`+res.data.colors.dominant.r+`%2c `+res.data.colors.dominant.g+`%2c `+res.data.colors.dominant.b+`%2c 1)'%3e%3c/rect%3e%3cpath d='M1266.74 249.36 a166.84 166.84 0 1 0 333.68 0 a166.84 166.84 0 1 0 -333.68 0z' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M395.909%2c258.245C429.983%2c258.337%2c450.119%2c224.278%2c467.028%2c194.696C483.754%2c165.433%2c500.356%2c132.194%2c485.155%2c102.11C468.815%2c69.773%2c432.118%2c52.673%2c395.909%2c53.948C361.73%2c55.152%2c332.267%2c77.468%2c316.925%2c108.034C303.03%2c135.717%2c311.04%2c166.897%2c325.455%2c194.312C341.274%2c224.396%2c361.92%2c258.153%2c395.909%2c258.245' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M1152.902%2c686.365C1204.407%2c686.667%2c1254.277%2c661.907%2c1279.192%2c616.828C1303.4%2c573.028%2c1294.923%2c519.677%2c1268.53%2c477.157C1243.649%2c437.073%2c1200.073%2c414.199%2c1152.902%2c413.372C1104.12%2c412.517%2c1055.52%2c431.373%2c1030.032%2c472.975C1003.457%2c516.352%2c1003.769%2c571.276%2c1029.153%2c615.361C1054.588%2c659.534%2c1101.931%2c686.066%2c1152.902%2c686.365' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M880.248%2c588.274C935.313%2c590.334%2c981.668%2c549.873%2c1007.588%2c501.246C1031.945%2c455.55%2c1030.73%2c400.625%2c1003.87%2c356.354C977.988%2c313.695%2c930.109%2c293.265%2c880.248%2c291.364C826.195%2c289.303%2c765.455%2c298.998%2c739.147%2c346.262C713.268%2c392.756%2c741.604%2c446.33%2c768.405%2c492.299C794.925%2c537.785%2c827.632%2c586.306%2c880.248%2c588.274' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M-6.276%2c551.408C9.078%2c551.621%2c24.067%2c544.339%2c31.495%2c530.9C38.715%2c517.837%2c35.598%2c502.152%2c28.075%2c489.26C20.623%2c476.488%2c8.499%2c466.76%2c-6.276%2c466.17C-22.091%2c465.538%2c-37.948%2c472.531%2c-45.735%2c486.311C-53.417%2c499.905%2c-50.369%2c516.524%2c-42.275%2c529.877C-34.507%2c542.692%2c-21.261%2c551.2%2c-6.276%2c551.408' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M989.806%2c476.324C1023.128%2c475.626%2c1055.244%2c462.931%2c1073.449%2c435.013C1093.526%2c404.224%2c1101.331%2c364.77%2c1083.511%2c332.621C1065.236%2c299.65%2c1027.501%2c284.512%2c989.806%2c284.112C951.311%2c283.704%2c911.956%2c297.323%2c892.591%2c330.595C873.129%2c364.035%2c878.394%2c406.462%2c899.865%2c438.649C919.198%2c467.63%2c954.976%2c477.054%2c989.806%2c476.324' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M1151.48 261.67 a151.62 151.62 0 1 0 303.24 0 a151.62 151.62 0 1 0 -303.24 0z' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M-105.66 451.58 a147.24 147.24 0 1 0 294.48 0 a147.24 147.24 0 1 0 -294.48 0z' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M577.369%2c226.401C591.96%2c225.933%2c605.192%2c218.379%2c612.686%2c205.85C620.395%2c192.961%2c621.569%2c177.256%2c614.772%2c163.864C607.256%2c149.055%2c593.975%2c136.431%2c577.369%2c136.264C560.536%2c136.094%2c546.731%2c148.337%2c538.637%2c163.097C530.879%2c177.244%2c529.473%2c194.488%2c537.893%2c208.25C545.994%2c221.491%2c561.854%2c226.899%2c577.369%2c226.401' fill='rgba(255%2c 255%2c 255%2c 0.15)' class='triangle-float3'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1030'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3cstyle%3e %40keyframes float1 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-10px%2c 0)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float1 %7b animation: float1 5s infinite%3b %7d %40keyframes float2 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-5px%2c -5px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float2 %7b animation: float2 4s infinite%3b %7d %40keyframes float3 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(0%2c -10px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float3 %7b animation: float3 6s infinite%3b %7d %3c/style%3e%3c/defs%3e%3c/svg%3e")`;
           this.background = backgroundChange;
            
            
            
            }).catch(err=>{
              console.log("___________COLOR________________");
              console.log(err);
            })

      }

      
      
    },

    getSongDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    },

    isLogin(){
      if(localStorage.getItem('accesstoken') === null){
        localStorage.clear();
        this.router.push('/app');
      }     
    },
    playMusic(url: string){
    const link = url.split('/')

    localStorage.setItem('player-link', link[3] + '/' + link[4])
    window.dispatchEvent(new CustomEvent('player-link-localstorage-changed', {
      detail: {
        storage: localStorage.getItem('player-link')
      }
    }));
    },
    facebook(){
      const url = 'https://www.facebook.com/sharer/sharer.php?u=https://nightingale-1d29b.web.app/music/recommended/p/'+ window.decodeURIComponent(this.finalid)
      window.open(url,'name','width=500,height=700')
    },
    twitter(){
      const urltwo = 'https://twitter.com/intent/tweet?text=https://nightingale-1d29b.web.app/music/recommended/p/'+ window.decodeURIComponent(this.finalid)
      window.open(urltwo,'name','width=500,height=700')
    },

    addToSpotify(){
      const url = 'https://us-central1-nightingale-1d29b.cloudfunctions.net/addPlaylistMusicsToSpotify?playlistId=' + this.finalid + '&playlistName=' + window.decodeURIComponent(this.titleOfPlayList) + '&userId=' +  window.decodeURIComponent(localStorage.getItem("userID") || "") +'&token=' + localStorage.getItem("accesstoken")
      this.presentLoading()
      axios.get(url)
      .then(
          res => {
              if(res.status == 200){
                  this.playlistAdded()

              window.dispatchEvent(new CustomEvent('playlist-deleted', {
                    detail: {
                      storage: 'added-Count'
                    }
                  }));


              }else{
                this.playlistAddedError()
              }
               window.dispatchEvent(new CustomEvent('playlist-deleted', {
                    detail: {
                      storage: 'added-Count'
                    }
                  }));
              
            })

    },
        async presentLoading() {
      const loading = await loadingController
        .create({
          spinner: 'circles',
          duration: this.timeout,
          message: 'Adding Playlist to Spotify',
          translucent: true,
          cssClass: 'custom-class custom-loading',
          backdropDismiss: false
        });

      await loading.present();

      setTimeout(function() {
        loading.dismiss()
      }, this.timeout);
    },

    async playlistAdded() {
      const loading = await loadingController
        .create({
          spinner: null,
          duration: this.timeout,
          message: 'Playlist Added to Spotify!',
          translucent: true,
          cssClass: 'custom-class custom-loading',
          backdropDismiss: false
        });

      await loading.present();

      setTimeout(function() {
        loading.dismiss()
      }, this.timeout);
    },
  
  async playlistAddedError() {
      const loading = await loadingController
        .create({
          spinner: null,
          duration: this.timeout,
          message: 'Unable to add, Please try again later',
          translucent: true,
          cssClass: 'custom-class custom-loading',
          backdropDismiss: false
        });

      await loading.present();

      setTimeout(function() {
        loading.dismiss()
      }, this.timeout);
    },
  
  },
  setup() {
    const router = useRouter();
     return {
       router,
      share, 
      logoTwitter, 
      triangle,
      radio,
      disc,
      logoFacebook
    }
  }
});

</script>



<style>


.coverImage{
  height: 250px;
  border-radius: 5px;
  text-align: center;
  align:center;
  margin-right:25px;
}

.playlistTitle{
  color: #EEEEEE;
  font-size: 65px;
}
.playlist{
  color: #EEEEEE;
}

.cover{
  padding-top:15px;
  padding-bottom:15px;
  padding-left:20px;
}

.grid{
  margin:0px;
  padding:0px;
}

.songList{
  padding-top:10px;
}

.songs{
  color: white;
  font-size: 25px;
  padding-left:15px;
}

ion-item{ 
  --border-color: #333333; 
  }


h3{
  color: white;
}


.share{
  top: 90% !important;
  right: 1% !important;

}
.artists{
  color: #919191 !important;
}
.list{
  padding-bottom: 90px
}
</style>